import React from 'react'
import {css} from '@emotion/core'

interface IPremierLabel {
  top?: boolean,
  bottom?: boolean,
  right?: boolean,
  left?: boolean,
}

const PremierLabel: React.FunctionComponent<IPremierLabel> = ({
  top, bottom, right, left,
}) => (
  <div
    className='premier-label'
    css={css`
          width: 30%;
          position: absolute;
          white-space: nowrap;
          text-indent: 2px;
          ${top && 'top: 5px;'}
          ${bottom && 'bottom: 5px;'}
          ${right && 'right: 5px;'}
          ${left && 'left: 5px;'}
        `}
  >
    <p>premier</p>
  </div>
)

export default PremierLabel
